import React from 'react';

export function initialsFromEmail(email) {
  return (
    email
      ?.split('@')[0]
      .split(/[.\-_]/)
      .filter(Boolean)
      .map((part) => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2) || '?'
  );
}

export default function Avatar({ email, online, size = 'md', className = '' }) {
  const sizes = {
    sm: 'h-9 w-9 text-xs',
    md: 'h-12 w-12 text-sm',
    lg: 'h-16 w-16 text-lg',
    xl: 'h-[4.5rem] w-[4.5rem] text-xl'
  };

  return (
    <span className={`relative inline-flex shrink-0 ${className}`}>
      <span
        className={`${sizes[size] || sizes.md} rounded-full bg-nest text-ink font-semibold inline-flex items-center justify-center shadow-float ring-2 ring-white`}
        aria-hidden="true"
      >
        {initialsFromEmail(email)}
      </span>
      {online && (
        <span className="absolute bottom-0 end-0 h-3 w-3 rounded-full bg-accent ring-2 ring-white" />
      )}
    </span>
  );
}
